import { FIXED_APP_EVENT_PREFIX } from '../..';

const getEventNameApp = (name: string) => `${FIXED_APP_EVENT_PREFIX}_${name}`;

export default getEventNameApp;
